@if (users == null || trainings == null || labels == null || departments == null || downloading == true) {
  <app-admin-spinner></app-admin-spinner>
}
<div class="row" style="margin-bottom: 3vh;">
  <!--<div class="col-12 col-xl-5 usersDiv" style="position: relative; background-color: #182038; margin: auto; width:90%; padding-right:0px">
  <h2>{{labels.lblUsers}}</h2>
  <form #insertFormUsers="ngForm" (ngSubmit)="generateReportForUsers()">
    <div class="row">
      <div class="col-12 col-lg-5" style="text-align: left;">
        <h4>{{labels.lblReportType}}:</h4>
      </div>
      <div class="col-12 col-lg-6" >
        <mat-form-field appearance="none" style="color:#8293c6">
          <mat-select ngModel name="type">
            <mat-option value="1">
              {{labels.lblSurvey}}
            </mat-option>
            <mat-option value="2">
              {{labels.lblTestResults}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-lg-5" style="text-align: left;">
        <h4>{{labels.lblTrainings}}</h4>
      </div>
      <div class="col-12 col-lg-6">
        <mat-form-field appearance="none" style="color:#8293c6">
          <mat-select ngModel name="trainingId">
            <mat-option *ngFor="let t of trainings" [value]="t">
              {{t.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-lg-5" style="text-align: left;">
        <h4>{{labels.lblUsers}}</h4>
      </div>
      <div class="col-12 col-lg-6" style="width:100%; float: left">
        <mat-form-field appearance="none" style="color:#8293c6">
          <mat-select ngModel name="userId" [formControl]="usersForReport" multiple>
            <mat-option *ngFor="let user of users" [value]="user._id">
              {{user.firstName}} {{user.lastName}}
            </mat-option>
          </mat-select>

        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-lg-5" style="text-align: left;">
        <h4 class="kalendarH">{{labels.lblFrom}} - {{labels.lblTo}}</h4>
      </div>
      <div class="col-12 col-lg-6">
        <div class="row"  style="float:right">
          <div class="col-12 col-lg-6" >
            <mat-form-field class="kalendar" appearance="none" >
              <input matInput [matDatepicker]="picker" ngModel name="fromDate"  style="color:#8293c6">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>

          <div class="col-12 col-lg-6">
            <mat-form-field  class="kalendar" appearance="none">
              <input matInput [matDatepicker]="picker2" ngModel name="toDate"  style="color:#8293c6">
              <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
              <mat-datepicker #picker2></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
    <div class="row btn" style="width:100%; margin-right: 0px; margin-bottom:0px; bottom:15px; right:40px;">
      <div class="col-12" style="text-align: right;">
        <button mat-raised-button class="tableBtn" cdkFocusInitial type="submit">{{labels.lblDownload}}</button>
      </div>
    </div>
  </form>
</div>-->
<!-- background-color: #202A4A -->
<!--<div class="col-12 col-xl-5 sektori" style="background-color: #182038; padding-right:0px;">
<h2>{{labels.lblSectors}}</h2>
<form #insertFormSectors="ngForm" (ngSubmit)="generateReportForSectors()">
  <div class="row">
    <div class="col-12 col-lg-5" style="text-align: left;">
      <h4>{{labels.lblReportType}}:</h4>
    </div>
    <div class="col-12 col-lg-6" >
      <mat-form-field appearance="none" style="color:#8293c6">
        <mat-select ngModel name="type">
          <mat-option value="1">
            {{labels.lblSurvey}}
          </mat-option>
          <mat-option value="2">
            {{labels.lblTestResults}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-lg-5" style="text-align: left;">
      <h4>{{labels.lblTrainings}}</h4>
    </div>
    <div class="col-12 col-lg-6">
      <mat-form-field appearance="none" style="color:#8293c6">
        <mat-select ngModel name="trainingId">
          <mat-option *ngFor="let t of trainings" [value]="t">
            {{t.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-lg-5" style="text-align: left;">
      <h4>{{labels.lblSectors}}</h4>
    </div>
    <div class="col-12 col-lg-6">
      <mat-form-field appearance="none" style="color:#8293c6">
        <mat-select ngModel name="depId">
          <mat-option *ngFor="let d of departments" [value]="d._id">
            {{d.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-lg-5" style="text-align: left;">
      <h4 class="kalendarH">{{labels.lblFrom}} - {{labels.lblTo}}</h4>
    </div>
    <div class="col-12 col-lg-6">
      <div class="row"  style="float:right">
        <div class="col-12 col-lg-6">
          <mat-form-field class="kalendar" appearance="none">
            <input matInput [matDatepicker]="picker3" ngModel name="fromDate"  style="color:#8293c6">
            <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
            <mat-datepicker #picker3></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="col-12 col-lg-6">
          <mat-form-field  class="kalendar" appearance="none">
            <input matInput [matDatepicker]="picker4" ngModel name="toDate"  style="color:#8293c6">
            <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
            <mat-datepicker #picker4></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
  <div class="row btn" style="width:100%; margin-right: 0px; margin-bottom:0px; bottom:15px; right:40px;">
    <div class="col-12" style="text-align: right;">
      <button mat-raised-button class="tableBtn" cdkFocusInitial type="submit">{{labels.lblDownload}}</button>
    </div>
  </div>
</form>
</div>
</div>-->
<!-- <mat-divider class="divider"></mat-divider> -->
<div class="row" style="margin-top:3vh">
  <div class="col-11" style=" margin: auto; background-color: #182038; padding-right:0px">
    <h2>{{labels.lblGeneratedReports}}</h2>
    <table style="background-color: #182038; color: white; width: 100%" matSortDisableClear="true" mat-table [dataSource]="dataSource" matSort>
    <!-- type Column -->
      <ng-container matColumnDef="type" >
        <th style="color: #8293c6" mat-header-cell *matHeaderCellDef mat-sort-header class="hideColumn"> {{labels.lblReportType}} </th>
        <td style="color: #8293c6" mat-cell *matCellDef="let generatedFile" class="hideColumn"> {{generatedFile.type}} </td>
      </ng-container>

      <!-- filename Column -->
      <ng-container matColumnDef="filename">
        <th style="color: #8293c6" mat-header-cell *matHeaderCellDef mat-sort-header class="hideColumn"> {{labels.lblDocumentName}} </th>
        <td style="color: #8293c6" mat-cell *matCellDef="let generatedFile" class="hideColumn"> {{generatedFile.filename}} </td>
      </ng-container>

      <!-- date Column -->
      <ng-container matColumnDef="date">
        <th style="color: #8293c6" mat-header-cell *matHeaderCellDef mat-sort-header class="hideColumn"> {{labels.lblDate}} </th>
        <td style="color: #8293c6" mat-cell *matCellDef="let generatedFile" class="hideColumn"> {{generatedFile.dateFrom ? formatDate(generatedFile.dateFrom, 'dd-MM-yyyy', 'en') : '/'}} - {{generatedFile.dateFrom ? formatDate(generatedFile.dateTo, 'dd-MM-yyyy', 'en') : formatDate(generatedFile.createdAt, 'dd-MM-yyyy', 'en')}} </td>
      </ng-container>

      <!-- Status Column -->
      <ng-container matColumnDef="status">
        <th style="color: #8293c6" mat-header-cell *matHeaderCellDef mat-sort-header> {{ labels.lblStatus}} </th>
        <td style="color: #8293c6" mat-cell *matCellDef="let generatedFile"> {{displayStatus(generatedFile.status)}} </td>
      </ng-container>

      <!-- style="color: #19a97e" -->
      <!--Actions column-->
      <ng-container matColumnDef="actions">
        <th style="color: #8293c6" mat-header-cell *matHeaderCellDef> {{labels.lblOptions}} </th>
        <td style="color: #8293c6" mat-cell *matCellDef="let generatedFile">
          <!-- <button class="editBtn d-none d-sm-inline-flex" (click)="openEditDialog(user)">
                      {{labels.lblEdit}}
                    </button>
                    <button class="deleteBtn d-none d-sm-inline-flex"  (click)="openDeleteDialog(user)">
                      {{labels.lblDelete}}
                    </button> -->
          <mat-icon class="settings" [matMenuTriggerFor]="settingsMenu">settings</mat-icon>
          <mat-menu #settingsMenu="matMenu" class="mMenu">
            <button mat-menu-item class="menuButton settingsMenuItem" [disabled]="generatedFile.status !== 'completed'" (click)="downloadReport(generatedFile)">
              <mat-icon style="color: #8293c6">download</mat-icon>
              <span style="color: #8293c6" class="aligned-with-icon"> {{labels.lblDownload}}</span>
            </button>
            <button style="color: #8293c6" mat-menu-item class="menuButton settingsMenuItem" [ngClass]="{'disabled-btn': admin.isAdmin == false}" (click)="openDeleteDialog(generatedFile)">
              <mat-icon style="color: #8293c6;">delete</mat-icon>
              <span class="aligned-with-icon"> {{labels.lblDelete}}</span>
            </button>
          </mat-menu>

          <!-- mobile -->
          <!-- <button class="editBtn d-block d-sm-none mobBtn" (click)="openEditDialog(user)">
            {{labels.lblEdit}}
          </button>
          <button class="deleteBtn d-block d-sm-none mobBtn" (click)="openDeleteDialog(user)">
            {{labels.lblDelete}}
          </button> -->
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
</div>

<div class="row" style="margin-top:3vh">
  <div class="col-12 col-xl-5" style=" margin: auto; background-color: #182038; padding-right:0px">
    <h2>General</h2>
    <form style="height:200px" #insertForm="ngForm" (ngSubmit)="generateReport()">
      <div class="row">
        <div class="col-12 col-lg-5" style="text-align: left;">
          <h4>{{labels.lblReportType}}:</h4>
        </div>
        <div class="col-12 col-lg-6" >
          <mat-form-field appearance="none" style="color:#8293c6">
            <mat-select ngModel name="type">
              <!--<mat-option value="1" (click)="changeMenuVisibility('1')">
                {{labels.lblSurvey}}
              </mat-option>
              <mat-option value="2" (click)="changeMenuVisibility('2')">
                {{labels.lblTestResults}}
              </mat-option>-->
              <mat-option value="3" (click)="changeMenuVisibility('3')">
                {{labels.lblGlobalReport}}
              </mat-option>
              <mat-option value="2" (click)="changeMenuVisibility('2')">
                {{labels.lblTrainingReport}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-lg-5" style="text-align: left;">
          <h4>{{labels.lblDate}}:</h4>
        </div>
        <div class="col-12 col-lg-6">
          <div class="row"  style="float:right">
            <div class="col-12 col-lg-6">
              <mat-form-field class="kalendar" appearance="none">
                <input matInput [matDatepicker]="picker3" ngModel name="dateFrom"  style="color:#8293c6">
                <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                <mat-datepicker #picker3></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="col-12 col-lg-6">
              <mat-form-field  class="kalendar" appearance="none">
                <input matInput [matDatepicker]="picker4" ngModel name="dateTo"  style="color:#8293c6">
                <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
                <mat-datepicker #picker4></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-lg-5" style="text-align: left;">
          <h4>{{labels.lblUserName || 'Username'}}:</h4>
        </div>
        <div class="col-12 col-lg-6">
          <mat-form-field appearance="none" style="color:#8293c6; width: 100%;">
            <input matInput ngModel name="username" style="color:#8293c6">
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-lg-5" style="text-align: left;">
          <h4>{{labels.lblSector || 'Sector'}}:</h4>
        </div>
        <div class="col-12 col-lg-6">
          <mat-form-field appearance="none" style="color:#8293c6">
            <mat-select ngModel name="sectorId">
              <mat-option [value]="null">
                {{labels.lblAll || 'All'}}
              </mat-option>
              @for (d of departments; track d) {
                <mat-option [value]="d._id">
                  {{d.name}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      @if (menuVisibility) {
        <div class="row">
          <div class="col-12 col-lg-5" style="text-align: left;">
            <h4>{{labels.lblTrainings}}</h4>
          </div>
          <div class="col-12 col-lg-6">
            <mat-form-field appearance="none" style="color:#182038">
              <!-- bind selected training to component property 'selectedTraining' -->
              <mat-select [(ngModel)]="selectedTraining" name="trainingId">
                @for (t of trainings; track t) {
                  <mat-option [value]="t">
                    {{t.name}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      }
      <div class="row btn" style="margin-right: 0px; margin-bottom:0px; ">
        <div class="col-12" style="text-align: right">
          <button mat-raised-button class="tableBtn" cdkFocusInitial type="submit">{{labels.lblDownload}}</button>
        </div>
      </div>
    </form>
  </div>

  <div class="col-12 col-lg-5" style="margin: auto; padding-left:0px; padding-right:0px; padding-bottom:25px; padding-top:25px;">
    <!-- pass selected training down to the status pie -->
    <app-status-pie [selectedTraining]="selectedTraining" class="statusPie"></app-status-pie>
  </div>
</div>
</div>
